module.exports = __webpack_public_path__ + "static/media/product-4.339554d5.png";